import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { CCTable } from "components/ui/Table";

import { CategoryItemBody } from "./CategoryItemBody";

export function AwardsByTermCategory({ category }) {
  const { title, headers = [], items = [] } = category;

  return (
    <ComparisonTable
      style={{ width: `100%` }}
      $grandTotal={title === "Grand Total"}
    >
      <thead>
        <tr>
          <th style={{ textAlign: `left` }}>{title}</th>

          {headers.map((header, index) => (
            <th key={index} style={{ width: `15%`, textAlign: `right` }}>
              {header}
            </th>
          ))}
        </tr>
      </thead>

      {items.map((item, index) => (
        <CategoryItemBody key={index} categoryItem={item} />
      ))}
    </ComparisonTable>
  );
}

AwardsByTermCategory.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string,
    headers: PropTypes.array,
    items: PropTypes.array,
  }),
};

const ComparisonTable = styled(CCTable)`
  width: 100%;

  tbody:last-child tr td {
    border-top: 1px solid var(--dusty-gray);
    font-weight: ${({ $grandTotal }) => ($grandTotal ? `bold` : `normal`)};
  }
`;
